/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Verify_DescInputs */

const en_fc_dl_verify_desc = /** @type {(inputs: Fc_Dl_Verify_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every release publishes SHA-256 checksums. Compare the hash of your file against the official list.`)
};

/**
* | output |
* | --- |
* | "Every release publishes SHA-256 checksums. Compare the hash of your file against the official list." |
*
* @param {Fc_Dl_Verify_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_verify_desc = /** @type {((inputs?: Fc_Dl_Verify_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Verify_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_verify_desc(inputs)
});
export { fc_dl_verify_desc as "fc.dl.verify.desc" }